import * as ExportRepo from '@/repository/export.js';

const state = {
	currentJob: null,
	jobPromise: null,
	jobLatest: null,
	startTime: 0,
	lastUpdate: 0,
};

const getters = {
	progress: (state) => {
		if (!state.jobLatest) return {};
		return state.jobLatest;
	},
	elapsed: (state) => {
		return state.lastUpdate - state.startTime;
	},
	rate: (state, getters) => {
		const p = state.jobLatest?.stats?.processed || 0;
		const el = getters.elapsed > 1000 ? getters.elapsed / 1000 : 1;
		return p / el;
	},
	eta: (state, getters) => {
		const rate = getters.rate;
		if (rate <= 0) return 0;
		const rem =
			(state.jobLatest?.stats?.estimated || 1) - (state.jobLatest?.stats?.processed || 0);
		return rem / rate;
	},
};

const mutations = {
	setCurrentJob(state, job) {
		state.currentJob = job;
	},
	setJobPromise(state, promise) {
		state.jobPromise = promise;
	},
	setJobLatest(state, job) {
		state.jobLatest = job;
	},
	setStartTime(state, time) {
		state.startTime = time;
	},
	setLastUpdate(state, time) {
		state.lastUpdate = time;
	},
	resetJob(state) {
		state.currentJob = null;
		state.jobPromise = null;
		state.jobLatest = null;
		state.startTime = 0;
		state.lastUpdate = 0;
	}
};

const actions = {
	async runJob({ commit, dispatch }, params) {
		console.log('run the job');

		if (params.config.length !== 36) {
			const tpl = await ExportRepo.getConfig({ alias: params.config });
			params.config = tpl.id;
		}
		const job = await ExportRepo.createJob(params);
		commit('setCurrentJob', job);
		return dispatch('tryContinue');
	},

	tryContinue({ state, commit }, jobId) {
		if (!state.currentJob) return;

		const startTime = Date.now();
		commit('setStartTime', startTime);

		const promise = ExportRepo.pollUntilJobComplete(
			jobId || state.currentJob.id,
			1000,
			1000 * 60 * 20,
			(update) => {
				if (startTime !== state.startTime || !state.currentJob) return;
				commit('setJobLatest', update);
				commit('setLastUpdate', Date.now());
			}
		);

		commit('setJobPromise', promise);
		return promise;
	},

	resetJob({ commit }) {
		commit('resetJob');
	},

	async loadLastJob({ state, dispatch }) {
		try {
			if (!state.currentJob?.id) return;
			const jobId = state.currentJob.id;
			const job = await ExportRepo.getJob({ id: jobId });
			if (['running', 'queued'].includes(job.status)) {
				dispatch('tryContinue', job.id);
			}
		} catch (e) {
			console.log('cannot load last job', e);
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};